// pages/eventos/clientes/painel/ListaEventosCliente.jsx

import React, { useEffect, useState } from "react";
import axios from "../../../../axiosConfig";
import { useNavigate } from "react-router-dom";
import "./ListaEventosCliente.css";

const ListaEventosCliente = () => {
  const [eventos, setEventos] = useState([]);
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 🏷️ Rótulos amigáveis para status
  const statusLabel = {
    aguardando_aprovacao: "Aguardando conferência",
    pontos_creditados: "Pontos creditados",
    resgate_criado: "Resgate gerado",
    premio_fisico_pendente: "Prêmio físico em preparo",
    em_analise: "Em análise",
    rejeitado: "Rejeitado"
  };

  useEffect(() => {
    const usuario = JSON.parse(localStorage.getItem("usuario"));
    if (!usuario?.id) {
      setErro("Você precisa estar logado para ver seus eventos.");
      setLoading(false);
      return;
    }

    axios
      .get(`/api/eventos/status-todos/${usuario.id}`)
      .then((res) => {
        const resultado = Array.isArray(res.data) ? res.data : res.data.eventos;
        if (Array.isArray(resultado)) {
          setEventos(resultado);
        } else {
          console.warn("Resposta inesperada da API de eventos:", res.data);
          setEventos([]);
        }
      })
      .catch(() => {
        setErro("Erro ao buscar seus eventos.");
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="status-loading">Carregando eventos...</div>;
  if (erro) return <div className="erro">{erro}</div>;

  return (
    <div className="painel-evento-status">
      <h1>Meus Eventos</h1>

      {!Array.isArray(eventos) || eventos.length === 0 ? (
        <p className="status-vazio">Você ainda não participou de nenhum evento.</p>
      ) : (
        <div className="tabela-eventos">
          {eventos.map((evento, index) => (
            <div key={index} className="card-evento">
              <div className="evento-cabecalho">
                <h3>{evento.evento}</h3>
                <span className={`status status-${evento.status}`}>
                  {statusLabel[evento.status] || evento.status?.replaceAll("_", " ")}
                </span>
              </div>
              <p className="data-evento">
                Participou em: {evento.data ? new Date(evento.data).toLocaleString("pt-BR") : "Data desconhecida"}
              </p>
              {evento.premio ? (
  <p className="observacao">
    Evento {evento.evento} - Prêmio: {evento.premio}
  </p>
) : (
  evento.observacao && <p className="observacao">{evento.observacao}</p>
)}

              <button onClick={() => navigate(`/eventos/painel/${evento.slug}`)}>
                Ver detalhes
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ListaEventosCliente;
